define('score_bootstrap/Components/ContentSearch/ActiveFacets',[
    "jquery",
    "knockout",    
    "underscore",
    "eventManager",
    "score_bootstrap/Events/SearchRequestChangeEvent"
], function defineActiveFiltersListingModule(
    $,
    ko,    
    _,
    eventManager,
    SearchRequestChangeEvent
) {
    "use strict";

    function getActiveFacets(searchRequest) {
        var activeFacets = searchRequest.facets.reduce(function(result, facet) {
            var selected = _.where(facet.values, { selected: true });
            if (selected) {
                Array.prototype.push.apply(result, selected);
            }

            return result;
        }, []);

        return activeFacets;
    }

    function getActiveRangeFacets(searchRequest) {
            var activeRangeFacets = searchRequest.rangeFacets.reduce(function(result, facet) {
            
           Array.prototype.push.apply(result, [{
                id: facet.id,
                value: facet.minValue + "-" + facet.maxValue
            }]);

            return result;
        }, []);

        return activeRangeFacets;
    }

    function getActiveRatingsFacets(searchRequest) {

            var activeRatingsFacets = searchRequest.ratingsFacets.reduce(function(result, facet) {
            
            Array.prototype.push.apply(result, [{
                id: facet.id,
                ratings: new Array(parseInt(facet.ratingValue, 10))
            }]);

            return result;
        }, []);

        return activeRatingsFacets;
    }

    function ActiveFacets(scope, refreshEvents) {
        var self = this;
        this.facets = ko.observableArray([]);
        this.rangeFacets = ko.observableArray([]);
        this.ratingsFacets = ko.observableArray([]);

        this.deselectFacet = function deselectFacet(facet) {
            refreshEvents.forEach(function (ev) {
                eventManager.trigger(SearchRequestChangeEvent.deselectFacet + ":" + ev, facet);
            });
        };

        this.clearAll = function clearAll() {
            refreshEvents.forEach(function (ev) {
                eventManager.trigger(SearchRequestChangeEvent.clearFacets + ":" + ev);
            });
        };

        refreshEvents.forEach(function (ev) {
            eventManager.subscribe(SearchRequestChangeEvent.eventName + ":" + ev, function (searchRequest) {
                // Pagination sends a message without facets data, so preserve facets selection
                if (searchRequest.facets) self.facets(getActiveFacets(searchRequest));
                if (searchRequest.rangeFacets) self.rangeFacets(getActiveRangeFacets(searchRequest));
                if (searchRequest.ratingsFacets) self.ratingsFacets(getActiveRatingsFacets(searchRequest));
                var hasActiveFacets = self.facets().length || self.rangeFacets().length || self.ratingsFacets().length;
                $('.clear-all', scope)
                    .toggleClass('disabled', !hasActiveFacets)
                    .attr('aria-disabled', !hasActiveFacets);
            });
        });

        ko.applyBindings(this, scope);
        $(scope).removeClass("js-hide-on-load");
    }

    ActiveFacets.init = function init(args) {
        if (args.IsEditorEditing === true) {
            $(args.scope).removeClass("js-hide-on-load");
            return null;
        }
        return new ActiveFacets(args.scope, args.RefreshActionMessages || []);
    };

    return ActiveFacets;
});
